import React, { Component } from 'react';
import BaseLayout from './BaseLayout';
import strings from '../strings';

export default class Downtime extends Component {
    render() {
        return (
            <BaseLayout>
                <div className="card m-t">
                    <div className="card-block">
                        <h2 className="card-title">                            
                            {strings.mapDowntime}
                        </h2>
                        <p className="text-description m-b-sm">
                            {process.env.DOWNTIME_MESSAGE}
                        </p>
                    </div>
                </div>
            </BaseLayout>
        );
    }
}



// WEBPACK FOOTER //
// ./app/views/Downtime.jsx